var modules_7b60ba63 = {"comments":"Rating_module_comments__8d1bb639"};
import "../../../../assets/esm/components/OfferCard/components/Rating/Rating~CSm6vz5H.css";

export { modules_7b60ba63 as default };
//# sourceMappingURL=Rating.module.scss.js.map
